import { useContext } from "react";
import { NotificationContext } from "../providers/NotificationProvider/NotificationProvider";

export const useNotificationContext = () => {
    return useContext(NotificationContext);
};
